import { createRouter, createWebHistory } from "vue-router";
// import { sources } from "@/reusable";
// import HomeView from '../views/HomeView.vue'
// import ErrorView from "@/views/ErrorView.vue";

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () => import("../views/FutureRent.vue"), // adjust path
  // },
  // {
  //   path: "/",
  //   name: "Application Form",
  //   component: () => import("../views/LeadsForm.vue"), // adjust path
  //   beforeEnter: async (to, from, next) => {
  //     const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
  //       const [name, value] = cookie.split("=");
  //       acc[name] = decodeURIComponent(value);
  //       return acc;
  //     }, {});

  //     try {
  //       if (to.query.source) {
  //         if (cookies.source) {
  //           to.meta.source = cookies.source;
  //           document.cookie = `source=${encodeURIComponent(
  //             cookies.source
  //           )}; path=/; Secure; SameSite=Strict`;
  //         } else {
  //           if (sources.includes(to.query.source)) {
  //             to.meta.source = to.query.source;
  //             document.cookie = `source=${encodeURIComponent(
  //               to.query.source
  //             )}; path=/; Secure; SameSite=Strict`;
  //           } else {
  //             return next({ name: "NotFound" });
  //           }
  //         }
  //       }
  //       if (to.query.campaign) {
  //         // Check if 'campaign' cookie exists
  //         if (cookies.campaign) {
  //           to.meta.campaign = cookies.campaign;
  //           console.log("Campaign cookie already set:", cookies.campaign);
  //           document.cookie = `campaign=${encodeURIComponent(
  //             cookies.campaign
  //           )}; path=/; Secure; SameSite=Strict`;
  //         } else {
  //           to.meta.campaign = to.query.campaign;
  //           console.log("Setting new campaign cookie:", to.query.campaign);
  //           document.cookie = `campaign=${encodeURIComponent(
  //             to.query.campaign
  //           )}; path=/; Secure; SameSite=Strict`;
  //         }
  //       }
  //       if (to.query.referrer) {
  //         if (cookies.referrer) {
  //           to.meta.referrer = cookies.referrer;
  //           console.log("referrer cookie already set:", cookies.referrer);
  //           document.cookie = `referrer=${encodeURIComponent(
  //             cookies.referrer
  //           )}; path=/; Secure; SameSite=Strict`;
  //         } else {
  //           to.meta.referrer = to.query.referrer;
  //           console.log("Setting new campaign cookie:", to.query.referrer);
  //           document.cookie = `referrer=${encodeURIComponent(
  //             to.query.referrer
  //           )}; path=/; Secure; SameSite=Strict`;
  //         }

  //         // to.meta.referrer = { campaign: to.query.referrer};
  //         // document.cookie = `referrer=${encodeURIComponent(to.query.referrer)}; path=/; Secure; SameSite=Strict`;
  //       }
  //       next();
  //     } catch (error) {
  //       console.error("Failed to fetch leads:", error);
  //       next(false); // Cancel navigation or redirect
  //     }
  //   },
  // },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/RedirectView.vue"),
    beforeEnter: async () => {
      window.location = "https://web.futurerent.co.za";
    },
  },
  {
    path: "/win-a-car",
    name: "win-a-car",
    component: () => import("../views/WinACar.vue"), // adjust path
    beforeEnter: async (to, from, next) => {
      const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
        const [name, value] = cookie.split("=");
        acc[name] = decodeURIComponent(value);
        return acc;
      }, {});

      try {
        if (to.query.referral) {
          if (cookies.referral) {
            to.meta.referral = cookies.referral;
            console.log("referral cookie already set:", cookies.referral);
            document.cookie = `referral=${encodeURIComponent(
              cookies.referral
            )}; path=/; Secure; SameSite=Strict`;
          } else {
            to.meta.referral = to.query.referral;
            console.log("Setting new campaign cookie:", to.query.referral);
            document.cookie = `referral=${encodeURIComponent(
              to.query.referral
            )}; path=/; Secure; SameSite=Strict`;
          }
        }
        next();
      } catch (error) {
        console.error("Failed to fetch leads:", error);
        next(false); // Cancel navigation or redirect
      }
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/ErrorView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
